import React from 'react';

import {
  SettingsResourcePagesEnum,
  SettingsTeammatesSubPagesEnum,
  SettingsTeammateUrl,
} from '../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {SettingsTeammateEditRule} from './settingsTeammateEditRule';
import {SettingsTeammatesImportCustomAttributes} from './settingsTeammatesImportCustomAttributes';

/*
 * Types.
 */

interface SettingsTeammateRootProps {
  panelId: SettingsPanelId;
  url: SettingsTeammateUrl;
  canImportCustomFieldAttributesCsv: boolean;
}

/*
 * Component.
 */

export const SettingsTeammates = (props: SettingsTeammateRootProps) => {
  const {panelId, url, canImportCustomFieldAttributesCsv} = props;
  const {resourcePage, ruleId, subPage, subResourcePage, teammateAlias, namespace} = url;

  if (resourcePage === SettingsResourcePagesEnum.EDIT) {
    if (subPage === SettingsTeammatesSubPagesEnum.RULES && subResourcePage && teammateAlias) {
      // TODO: Split it into another file when we will migrate SettingsTeammate to front-client.
      return (
        <SettingsTeammateEditRule
          panelId={panelId}
          namespace={namespace}
          teammateAlias={teammateAlias}
          subResourcePage={subResourcePage}
          ruleId={ruleId}
          url={url}
        />
      );
    }
  }

  if (
    canImportCustomFieldAttributesCsv &&
    resourcePage === SettingsResourcePagesEnum.IMPORT_CUSTOM_ATTRIBUTES
  ) {
    return <SettingsTeammatesImportCustomAttributes url={url} />;
  }

  return null;
};
